export default function Checkbox({ value, onChange, label }) {
  return (
    <label className="lfx-checkbox-label">
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
        className="lfx-checkbox"
      />
      {label}
    </label>
  );
}
